import type { QueryClient } from '@tanstack/react-query';

/**
 * Query keys of every cached view of the customers list.
 * Kept in one place so all customer write paths refresh the same set.
 */
export const customerListQueryKeys: string[][] = [
  ['customers'],
  ['customers-dashboard'],
  ['customers-graphql-list'],
  ['customers-graphql-count'],
  ['customers-graphql-totals'],
  ['customers-graphql-currency-aggregation'],
];

/**
 * Invalidates every cached customers list query and resolves once the rendered
 * ones have refetched, so a customer write is visible before the caller reports
 * success. Queries that are cached but not rendered are only marked stale —
 * they belong to another company or filter and must refetch with their own
 * headers when they are next used.
 */
export function invalidateCustomerListQueries(queryClient: QueryClient): Promise<void[]> {
  return Promise.all(customerListQueryKeys.map((queryKey) => queryClient.invalidateQueries({ queryKey })));
}
